// US passenger vehicles by make → models, covering MY 2013–2026.
// Compact list (top sellers + livery favourites). Not exhaustive but fast to ship.
export const VEHICLE_YEARS = Array.from({ length: 14 }, (_, i) => 2026 - i);

export const VEHICLE_COLORS = [
  "Black", "White", "Silver", "Gray", "Charcoal", "Red", "Blue", "Navy", "Green",
  "Yellow", "Orange", "Brown", "Beige/Tan", "Gold", "Maroon", "Other",
];

export const VEHICLE_MAKES = {
  Toyota: ["Camry", "Corolla", "Avalon", "Prius", "Highlander", "RAV4", "Sienna", "Sequoia", "Tundra", "Tacoma", "4Runner", "Venza", "Crown"],
  Honda: ["Accord", "Civic", "Insight", "Pilot", "Passport", "CR-V", "HR-V", "Odyssey", "Ridgeline"],
  Ford: ["Fusion", "Taurus", "Focus", "Escape", "Edge", "Explorer", "Expedition", "F-150", "F-250", "F-350", "Transit", "Transit Connect", "Bronco", "Maverick"],
  Chevrolet: ["Malibu", "Impala", "Cruze", "Sonic", "Equinox", "Traverse", "Tahoe", "Suburban", "Silverado 1500", "Silverado 2500", "Express", "Trailblazer"],
  GMC: ["Acadia", "Terrain", "Yukon", "Yukon XL", "Sierra 1500", "Sierra 2500", "Savana"],
  Nissan: ["Altima", "Maxima", "Sentra", "Versa", "Rogue", "Murano", "Pathfinder", "Armada", "Frontier", "Titan", "NV200", "NV1500", "NV3500"],
  Hyundai: ["Elantra", "Sonata", "Accent", "Azera", "Tucson", "Santa Fe", "Palisade", "Kona", "Ioniq", "Ioniq 5", "Ioniq 6"],
  Kia: ["Forte", "Optima", "K5", "Rio", "Soul", "Sportage", "Sorento", "Telluride", "Carnival", "Sedona", "Niro", "EV6"],
  Mazda: ["Mazda3", "Mazda6", "CX-3", "CX-30", "CX-5", "CX-9", "CX-50", "CX-90"],
  Subaru: ["Impreza", "Legacy", "Outback", "Forester", "Crosstrek", "Ascent", "WRX"],
  Volkswagen: ["Jetta", "Passat", "Arteon", "Tiguan", "Atlas", "Atlas Cross Sport", "Taos", "ID.4"],
  Chrysler: ["300", "Pacifica", "Voyager"],
  Dodge: ["Charger", "Challenger", "Durango", "Grand Caravan", "Journey"],
  Jeep: ["Cherokee", "Grand Cherokee", "Grand Cherokee L", "Wrangler", "Compass", "Renegade", "Wagoneer", "Grand Wagoneer", "Gladiator"],
  Ram: ["1500", "2500", "3500", "ProMaster", "ProMaster City"],
  Buick: ["Encore", "Encore GX", "Envision", "Enclave", "LaCrosse", "Regal"],
  Cadillac: ["CT4", "CT5", "CT6", "XT4", "XT5", "XT6", "Escalade", "Escalade ESV", "Lyriq"],
  Lincoln: ["MKZ", "Continental", "Aviator", "Nautilus", "Navigator", "Corsair"],
  Lexus: ["ES", "IS", "GS", "LS", "RX", "GX", "LX", "NX", "RZ"],
  Acura: ["TLX", "ILX", "RDX", "MDX", "ZDX"],
  Infiniti: ["Q50", "Q60", "Q70", "QX50", "QX55", "QX60", "QX80"],
  BMW: ["3 Series", "5 Series", "7 Series", "X1", "X3", "X5", "X7", "i4", "iX"],
  "Mercedes-Benz": ["C-Class", "E-Class", "S-Class", "GLA", "GLB", "GLC", "GLE", "GLS", "Sprinter", "Metris", "EQS", "EQE"],
  Audi: ["A3", "A4", "A6", "A8", "Q3", "Q5", "Q7", "Q8", "e-tron"],
  Tesla: ["Model 3", "Model S", "Model X", "Model Y", "Cybertruck"],
  Volvo: ["S60", "S90", "XC40", "XC60", "XC90"],
  Mitsubishi: ["Outlander", "Outlander Sport", "Eclipse Cross", "Mirage"],
  Mercury: ["Grand Marquis", "Marauder"],  // older models still on the road
  Other: ["Other"],
};

export const VEHICLE_MAKE_LIST = Object.keys(VEHICLE_MAKES).sort();
